import { Injectable } from '@angular/core';
import { RouterOutlets } from '@rootTypes/entities/router';
import { PortalRouterService } from '../../types/portal-router-service';
import { createPortalRoute } from '../../utils/create-portal-route';

export type VendorEmployeeAccessManagerRouteData = {
  employeeId: string;
};

export const vendorEmployeeAccessManagerRoute = createPortalRoute<VendorEmployeeAccessManagerRouteData>({
  path: ':employeeId/yard-access/manage',
  prefix: 'vendor-employees',

  outlet: RouterOutlets.DRAWER,
});

@Injectable({ providedIn: 'root' })
export class VendorEmployeeAccessManagerRouterService extends PortalRouterService<VendorEmployeeAccessManagerRouteData> {
  readonly route = vendorEmployeeAccessManagerRoute;
}
